import * as z from "zod";

const ExclusionFieldSchema_ = z.enum(["tags", "collections"]);
export const ExclusionFieldSchema: z.ZodType<ExclusionField> =
  ExclusionFieldSchema_;
export type ExclusionField = {} & z.infer<typeof ExclusionFieldSchema_>;

export const getExclusionOptions = {
  name: "getExclusionOptions" as const,
  input: z.object({
    field: ExclusionFieldSchema,
    search: z.string().optional(),
  }),
  output: z.object({ options: z.array(z.string()) }),
};
